import { memo } from 'react';

import { PrivateWorkspaceAgentPanelZeroState } from '~/components/v2/components/workspace/workspace-agent-panel/components/composer/PrivateWorkspaceAgentPanelZeroState';
import { PrivateWorkspaceAgentOnboardingTimeSinks } from '~/components/v2/components/workspace/workspace-agent-panel/components/messages/PrivateWorkspaceAgentOnboardingTimeSinks';
import { useWorkspaceAgentOnboardingRole } from '~/components/v2/components/workspace/workspace-agent-panel/hooks/onboarding/useWorkspaceAgentOnboardingRole';
import { useWorkspaceAgentOnboardingTimeSinkIds } from '~/components/v2/components/workspace/workspace-agent-panel/hooks/onboarding/useWorkspaceAgentOnboardingTimeSinkIds';

/** An empty thread is the usual suggestions, unless the intro just handed off answers to play. */
export const PrivateWorkspaceAgentPanelEmptyThread = memo(() => {
  const { role } = useWorkspaceAgentOnboardingRole();
  const { timeSinkIds } = useWorkspaceAgentOnboardingTimeSinkIds();

  if (role && timeSinkIds.length > 0) {
    return <PrivateWorkspaceAgentOnboardingTimeSinks role={role} timeSinkIds={timeSinkIds} />;
  }

  return <PrivateWorkspaceAgentPanelZeroState />;
});

PrivateWorkspaceAgentPanelEmptyThread.displayName = 'PrivateWorkspaceAgentPanelEmptyThread';
